import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#eye-off-clip0_2249_853)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M1.707.293A1 1 0 0 0 .293 1.707L4.545 5.96a19.5 19.5 0 0 0-4.426 5.534 1 1 0 0 0-.014.92L1 11.966l-.894.447v.001l.001.002.004.007.011.023a8 8 0 0 0 .192.355 20.753 20.753 0 0 0 2.84 3.866C5.122 18.764 8.128 21 12.04 21h.016a11.1 11.1 0 0 0 5.79-1.741l4.448 4.448a1 1 0 0 0 1.414-1.414l-4.816-4.817a1 1 0 0 0-.184-.252l-3.83-3.832-.006-.007-4.25-4.252-.006-.007-3.83-3.833a1 1 0 0 0-.27-.193zm12.345 15.174 2.336 2.335A9.1 9.1 0 0 1 12.031 19c-3.109-.003-5.62-1.783-7.416-3.7a18.8 18.8 0 0 1-2.473-3.331 17.5 17.5 0 0 1 3.821-4.592L8.54 9.953a4.02 4.02 0 0 0-.294 3.59 4.01 4.01 0 0 0 3.79 2.51 4 4 0 0 0 2.017-.586m-4.012-4.012 2.512 2.51a2.007 2.007 0 0 1-2.452-1.17 2 2 0 0 1-.06-1.34m10.33 4.234a1 1 0 0 1-.146-1.407 17.5 17.5 0 0 0 1.573-2.285 18.674 18.674 0 0 0-2.462-3.313c-1.789-1.909-4.29-3.68-7.387-3.684a9 9 0 0 0-1.864.226 1 1 0 1 1-.445-1.95c.746-.17 1.511-.263 2.285-.276h.016c3.9 0 6.896 2.226 8.855 4.316a20.7 20.7 0 0 1 2.831 3.85 13 13 0 0 1 .192.354l.011.022.003.007.002.002v.001L22.94 12l.894-.447a1 1 0 0 1-.013.92 19.5 19.5 0 0 1-2.045 3.07 1 1 0 0 1-1.407.146",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "eye-off-clip0_2249_853" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }